module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "inter"
  }, [_c('div', {
    staticClass: "mobile-flex flex-row items-center pl2 pr2 pb2",
    on: {
      "click": _vm.goBack
    }
  }, [_c('arrow-back1'), _vm._v(" "), _c('h3', {
    staticClass: "ml3 f4 cera-round-pro"
  }, [_vm._v(_vm._s(_vm.$t('menu.loginsecurity', {
    loginsecurity: 'Login & Security'
  })))])], 1), _vm._v(" "), (!_vm.editEmail) ? _c('div', {
    staticClass: "mv2 ph3 flex flex-column justify-center items-start height-dv"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('span', {
    staticClass: "mt1 silver-element"
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.emaill', {
    emaill: 'Email'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-between w-100"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('span', {
    staticClass: "color-theme data pointer",
    on: {
      "click": _vm.editEmailAddress
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.edit', {
    edit: 'Edit'
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.editEmail) ? _c('div', {
    staticClass: "row-edit mv2 desktop modal-opened-row"
  }, [_c('span', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.editemail', {
    editemail: 'Edit your email address'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('form', {
    staticClass: "flex-column"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.emailu', {
    emailu: 'EMAIL'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex justify-between justify-end-ns"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "inter fw6 modal-button cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "inter modal-button fw6 save",
    attrs: {
      "disabled": _vm.emailError,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateEmail.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.editEmail) ? _c('div', {
    staticClass: "modal flex-row mobile w-75"
  }, [_c('form', {
    staticClass: "flex-column mh3 mt4"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('loginsettings.editemailm', {
    editemailm: 'Edit Email'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "email-mobile"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.emailu', {
    emailu: 'EMAIL'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "email-mobile",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex mh4 flex-row pb3 justify-between"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "disabled": _vm.emailError,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateEmail.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n          ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "line mh3"
  }), _vm._v(" "), (!_vm.editPhone) ? _c('div', {
    staticClass: "mv2 ph3 flex flex-column justify-center items-start height-dv"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('span', {
    staticClass: "mt1 silver-element"
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.phonel', {
    phonel: 'Phone Number'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-between w-100"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.formatPhoneNumber))]), _vm._v(" "), _c('span', {
    staticClass: "color-theme data pointer",
    on: {
      "click": _vm.updatePhoneShow
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.edit', {
    edit: 'Edit'
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.editPhone && _vm.isDesktop && !_vm.showPhoneVerificationModal) ? _c('div', {
    staticClass: "row-edit mv2 desktop modal-opened-row"
  }, [_c('span', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.editphone', {
    editphone: 'Edit your phone number'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('form', {
    staticClass: "flex-column"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.phoneu', {
    phoneu: 'PHONE NUMBER'
  })))]), _vm._v(" "), _c('InputMask', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "phone",
      "mask": "(999) 999-9999",
      "type": "tel"
    },
    model: {
      value: (_vm.phone_no),
      callback: function($$v) {
        _vm.phone_no = $$v
      },
      expression: "phone_no"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneErrorMessage),
      expression: "phoneErrorMessage"
    }],
    staticClass: "f6 red mh3-ns",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n              " + _vm._s(_vm.phoneErrorMessage) + "\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex justify-between justify-end-ns"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "inter fw6 modal-button cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "inter modal-button fw6 save",
    attrs: {
      "disabled": !_vm.canUpdatePhone,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatePhone.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.editPhone && _vm.isDesktop && _vm.showPhoneVerificationModal) ? _c('div', {
    staticClass: "row mv2 desktop modal-opened-row"
  }, [_c('span', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.phonecodeverify', {
    phonecodeverify: 'A verification code was sent to your new phone number'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('form', {
    staticClass: "flex-column",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "phone_verification_code"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.phonecode', {
    phonecode: 'CODE'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_verification_code),
      expression: "phone_verification_code"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "phone_verification_code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone_verification_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_verification_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneVerificationErrorMessage),
      expression: "phoneVerificationErrorMessage"
    }],
    staticClass: "f6 red mh3-ns",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n              " + _vm._s(_vm.phoneVerificationErrorMessage) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-row justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 save",
    attrs: {
      "disabled": !_vm.canVerifyPhoneCode,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.verifyPhoneVerificationCode.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.editPhone && !_vm.isDesktop) ? _c('div', {
    staticClass: "modal flex-row mobile w-75"
  }, [(_vm.editPhone && !_vm.isDesktop && !_vm.showPhoneVerificationModal) ? _c('div', [_c('form', {
    staticClass: "flex-column mh3 mt4"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('loginsettings.editphonem', {
    editphonem: 'Edit Phone Number'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "phone-mobile"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.phoneu', {
    phoneu: 'PHONE NUMBER'
  })))]), _vm._v(" "), _c('InputMask', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "phone-mobile",
      "mask": "(999) 999-9999",
      "type": "tel"
    },
    model: {
      value: (_vm.phone_no),
      callback: function($$v) {
        _vm.phone_no = $$v
      },
      expression: "phone_no"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneErrorMessage),
      expression: "phoneErrorMessage"
    }],
    staticClass: "f6 red mh3-ns",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n              " + _vm._s(_vm.phoneErrorMessage) + "\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex mh4 flex-row pb3 justify-between"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "disabled": !_vm.canUpdatePhone,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatePhone.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n            ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.editPhone && !_vm.isDesktop && _vm.showPhoneVerificationModal) ? _c('div', [_c('form', {
    staticClass: "flex-column mh3 mt4"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('loginsettings.phonecodeverify', {
    phonecodeverify: 'A verification code was sent to your new phone number'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "phone_verification_code_mobile"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.phonecode', {
    phonecode: 'CODE'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_verification_code),
      expression: "phone_verification_code"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "phone_verification_code_mobile",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone_verification_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_verification_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneVerificationErrorMessage),
      expression: "phoneVerificationErrorMessage"
    }],
    staticClass: "f6 red mh3-ns",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n              " + _vm._s(_vm.phoneVerificationErrorMessage) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex mh4 flex-row pb3 justify-between",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "inter modal-button",
    attrs: {
      "disabled": !_vm.canVerifyPhoneCode,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.verifyPhoneVerificationCode.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n            ")])], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "line mh3"
  }), _vm._v(" "), (!_vm.editPassword && !_vm.isErrorPassword) ? _c('div', {
    staticClass: "ph3 mv2 flex flex-column justify-center items-start height-dv"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('span', {
    staticClass: "mt1 silver-element"
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.passwordl', {
    passwordl: 'Password'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-between w-100"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v("∗∗...∗∗")]), _vm._v(" "), _c('span', {
    staticClass: "color-theme data pointer",
    on: {
      "click": _vm.updatePasswordShow
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.edit', {
    edit: 'Edit'
  })))])])]) : _vm._e(), _vm._v(" "), (_vm.editPassword || _vm.isErrorPassword) ? _c('div', {
    staticClass: "row-edit mv2 desktop modal-opened-row"
  }, [_c('div', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('loginsettings.editpassword', {
    editpassword: 'Edit your password'
  })) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('form', {
    staticClass: "flex-column",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "current"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.passwordcurrent', {
    passwordcurrent: 'CURRENT PASSWORD'
  })))]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "current",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.current) ? _vm._i(_vm.current, null) > -1 : (_vm.current)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.current,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.current = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.current = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.current = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "current",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.current, null)
    },
    on: {
      "change": function($event) {
        _vm.current = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "current",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isErrorPassword),
      expression: "isErrorPassword"
    }],
    staticClass: "f6 red mh3-ns current-error",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n            " + _vm._s(this.$store.state.errors[0]) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "pass"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.passwordnew', {
    passwordnew: 'NEW PASSWORD'
  })))]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "pass",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "pass",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "pass",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "confirm"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.passwordconfirm', {
    passwordconfirm: 'CONFIRM PASSWORD'
  })))]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "confirm",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirm) ? _vm._i(_vm.confirm, null) > -1 : (_vm.confirm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirm = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "confirm",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.confirm, null)
    },
    on: {
      "change": function($event) {
        _vm.confirm = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "confirm",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.confirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb3 flex-grow mh3-ns flex items-center"
  }, [_c('a', {
    staticClass: "underline pointer color-theme f7",
    on: {
      "click": function($event) {
        _vm.showPasswords = !_vm.showPasswords
      }
    }
  }, [_vm._v(_vm._s(_vm.showPasswords ? _vm.$t('loginsettings.passwordhide', {
    passwordhide: 'Hide Password'
  }) : _vm.$t('loginsettings.passwordshow', {
    passwordshow: 'Show Password'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "f65 red ml3 mb2",
    class: (_vm.passwordLength) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n            " + _vm._s((_vm.passwordLength) ? '✓' : '✘') + "\n            " + _vm._s(_vm.$t('loginsettings.passwordtip1', {
    passwordtip1: 'At least 8 characters long'
  })) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 red ml3 mb2",
    class: (_vm.passwordUpper) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n            " + _vm._s(_vm.passwordUpper ? '✓' : '✘') + "\n            " + _vm._s(_vm.$t('loginsettings.passwordtip2', {
    passwordtip2: 'Contain at least one uppercase character'
  })) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 red ml3 mb2",
    class: (_vm.passwordLower) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n            " + _vm._s(_vm.passwordLower ? '✓' : '✘') + "\n            " + _vm._s(_vm.$t('loginsettings.passwordtip3', {
    passwordtip3: 'Contain at least one lowercase character'
  })) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 red ml3 mb2",
    class: (_vm.passwordNumber) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n            " + _vm._s(_vm.passwordNumber ? '✓' : '✘') + "\n            " + _vm._s(_vm.$t('loginsettings.passwordtip4', {
    passwordtip4: 'Contain at least one number'
  })) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 red ml3 mb2",
    class: (_vm.passwordSpecial) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n            " + _vm._s(_vm.passwordSpecial ? '✓' : '✘') + "\n            " + _vm._s(_vm.$t('loginsettings.passwordtip5', {
    passwordtip5: 'Contain at least one special character'
  })) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 red ml3 mb4",
    class: (_vm.passwordsMatch) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n            " + _vm._s(_vm.passwordsMatch ? '✓' : '✘') + " " + _vm._s(_vm.$t('loginsettings.passwordtip6', {
    passwordtip6: 'Passwords match'
  })) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-row justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 save",
    attrs: {
      "disabled": !_vm.validPassword || _vm.current === '',
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatePassword.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.editPassword || _vm.isErrorPassword) ? _c('div', {
    staticClass: "modal flex-row mobile w-75"
  }, [_c('form', {
    staticClass: "flex-column mh3 mt4"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('loginsettings.editpasswordm', {
    editpasswordm: 'New Password'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "current-mobile"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.passwordcurrent', {
    passwordcurrent: 'CURRENT PASSWORD'
  })))]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "current-mobile",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.current) ? _vm._i(_vm.current, null) > -1 : (_vm.current)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.current,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.current = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.current = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.current = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "current-mobile",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.current, null)
    },
    on: {
      "change": function($event) {
        _vm.current = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "current-mobile",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.current)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isErrorPassword),
      expression: "isErrorPassword"
    }],
    staticClass: "f6 red mh3-ns current-error",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(this.$store.state.errors[0]) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "pass-mobile"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.passwordnew', {
    passwordnew: 'NEW PASSWORD'
  })))]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "pass-mobile",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "pass-mobile",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "pass-mobile",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "confirm-mobile"
    }
  }, [_vm._v(_vm._s(_vm.$t('loginsettings.passwordconfirm', {
    passwordconfirm: 'CONFIRM PASSWORD'
  })))]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "confirm-mobile",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirm) ? _vm._i(_vm.confirm, null) > -1 : (_vm.confirm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirm = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "confirm-mobile",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.confirm, null)
    },
    on: {
      "change": function($event) {
        _vm.confirm = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "confirm-mobile",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.confirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb3 flex-grow mh3-ns flex items-center"
  }, [_c('a', {
    staticClass: "underline pointer color-theme f7",
    on: {
      "click": function($event) {
        _vm.showPasswords = !_vm.showPasswords
      }
    }
  }, [_vm._v(_vm._s(_vm.showPasswords ? 'Hide Password' : 'Show Password'))])]), _vm._v(" "), _c('div', {
    staticClass: "f65 mh3-ns mb1",
    class: (_vm.passwordLength) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s((_vm.passwordLength) ? '✓' : '✘') + "\n          " + _vm._s(_vm.$t('loginsettings.passwordtip1', {
    passwordtip1: 'At least 8 characters long'
  })) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 mh3-ns mb1",
    class: (_vm.passwordUpper) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.passwordUpper ? '✓' : '✘') + "\n          " + _vm._s(_vm.$t('loginsettings.passwordtip2', {
    passwordtip2: 'Contain at least one uppercase character'
  })) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 mh3-ns mb1",
    class: (_vm.passwordLower) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.passwordLower ? '✓' : '✘') + "\n          " + _vm._s(_vm.$t('loginsettings.passwordtip3', {
    passwordtip3: 'Contain at least one lowercase character'
  })) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 mh3-ns mb1",
    class: (_vm.passwordNumber) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.passwordNumber ? '✓' : '✘') + "\n          " + _vm._s(_vm.$t('loginsettings.passwordtip4', {
    passwordtip4: 'Contain at least one number'
  })) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 mh3-ns mb1",
    class: (_vm.passwordSpecial) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.passwordSpecial ? '✓' : '✘') + "\n          " + _vm._s(_vm.$t('loginsettings.passwordtip5', {
    passwordtip5: 'Contain at least one special character'
  })) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "f65 mh3-ns mb3",
    class: (_vm.passwordsMatch) ? 'green' : 'red',
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.passwordsMatch ? '✓' : '✘') + " " + _vm._s(_vm.$t('loginsettings.passwordtip6', {
    passwordtip6: 'Passwords match'
  })) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex mh-responsive flex-row pb3 justify-between"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "disabled": !_vm.validPassword || _vm.current === '',
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatePassword.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n          ")])], 1)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a21ea0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/security/LoginAndSecurity.vue
// module id = 1158
// module chunks = 0